
import './assets/style.css';
import './assets/bootstrap.min.css';
import './assets/custom_style_nav.css';
import './assets/custom_style.css';



const UtradeLogin = () => {
    return (
        <div className="utradeBody">
        
        </div>
    );
};

export default UtradeLogin;
